<template>
  <div />
</template>

<script>
// Vuex
import { mapActions } from 'vuex';

// Utils
import {
  getQuestionnaireObject,
  getAnswerFromLocalStorage,
} from 'utils/questionnaire';

export default {
  name: 'intake-progress',

  // Methods
  methods: {
    ...mapActions('app', ['setErrorMessage', 'setErrorRedirect']),

    checkIntakeRequirements(localStorageItems, questionnaireId, questions, destination) {
      // All entries need to be truthy to complete the check
      // Will be added based on the requested checks
      let checks = {};

      // Debuggin
      // console.log(`### localStorageItems`, localStorageItems);
      // console.log(`### questionnaireId`, questionnaireId);
      // console.log(`### questions`, questions);
      // console.log(`### destination`, destination);

      // If we passed an array with items to check or passed 'default' we check if each item is set in localstorage
      if ( localStorageItems ) {
        checks = {
          answerWho: null, // myself
          answerLocation: null,
          answerComplaint: null,
        };

        const ItemsToCheck = localStorageItems === 'default' ? Object.keys(checks) : localStorageItems;

        _.forEach(ItemsToCheck, item => { // eslint-disable-line no-undef
          if ( localStorage.getItem(item) ) {
            checks[item] = true;
          }
        });
      }

      // If a questionnaire ID has been provided we check the following based on length or provider question ID:
      // - Does the questionnaire exist
      // - Does the questionnaire have any items
      // - Are there more items stored then required to pass
      // - Does the answer of the question excist in localStorage
      if ( questionnaireId && questions ) {
        if ( getQuestionnaireObject(questionnaireId) ) {
          if ( questions === 'length' || _.isInteger(questions) ) { // eslint-disable-line no-undef
            const storedAnswersCount = Object.keys(getQuestionnaireObject(questionnaireId)).length;
            const requestedAmount = _.isInteger(questions) ? questions : 0; // eslint-disable-line no-undef

            checks.meetsLengthRequirement = storedAnswersCount > requestedAmount;
          } else {
            _.forEach(questions, q => { // eslint-disable-line no-undef
              checks[q] = !!getAnswerFromLocalStorage(questionnaireId, q);
            });
          }
        } else {
          checks.meetsLengthRequirement = false;
        }
      }

      // Debugging
      // console.log(`checks`, checks);
      // console.log(`All true`, this.allTrue(checks));

      // If destination is provided, redirect to this destination
      if ( destination && !this.allTrue(checks) ) {
        this.redirectTo(destination);
      }

      // Return true or false based on all the previous checks
      return this.allTrue(checks);
    },

    // Check if all items in object are true
    allTrue(obj) {
      for (const o in obj)
        if (!obj[o]) return false;

      return true;
    },

    redirectTo(destination) {
      const redirectMapping = {
        support: {
          errorMessage: 'We\'re missing some information from you for this step; please go back and be sure to answer every question.',
          errorRedirect: { link: 'support', label: 'Answer Questions' },
        },
        appointmentType: {
          errorMessage: 'We\'re missing some information from you for this step; please go back and be sure to answer every question.',
          errorRedirect: { link: 'appointment-type', label: 'Select Appointment' },
        },
        home: {
          errorMessage: 'We\'re missing some information from you for this step; please go back and be sure to answer every question.',
          errorRedirect: { link: 'home', label: 'Go back' },
        },
        help: {
          errorMessage: 'We\'re missing some information from you for this step; please go back and be sure to answer every question.',
          errorRedirect: { link: 'help-myself', label: 'Go back' },
        },
        appointmentTypeNoData: {
          errorMessage: 'We\'re missing some information about your choice of appointment type - please go back and choose.',
          errorRedirect: { link: 'appointment-type', label: 'Select Appointment' },
        },
      };

      this.setErrorMessage(redirectMapping[destination].errorMessage);
      this.setErrorRedirect(redirectMapping[destination].errorRedirect);

      this.$nextTick(() => {
        this.$router.push({ name: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// IntakeProgress.vue?0d6f4173